<template>
  <div id="abc" v-if="all">
    <div id="list" :class="{entered}">
      <div v-for="(item, index) in all" :key="'letter' + index">
        <div class="upper">
          <div class="title">{{item.letter}}</div>
        </div>

        <div v-for="(person, pIndex) in item.contacts" :key="person.title + pIndex">
          <router-link  @click.native="goToRoute($event, person.year.title, person.slug)" event="" :to="'/laureat/' + person.year.title + '/' + person.slug">
            <div class="person"><span v-html="person.title"></span><span v-html="checkYear(index, pIndex)"></span></div>
          </router-link>
        </div>
      </div>
    </div>

    <transition name="l-fade" mode="out-in" appear @after-enter="afterEnter">
      <router-view :key="$route.params.slug"/>
    </transition>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      entered: false,
      selected: false
    }
  },

  computed: {
    all () {
      if (this.$store.getters.all) {
        let all = this.$store.getters.all
        let nAll = []

        all.forEach(entry => {
          let names = entry.abc.split(',').map(item => item.trim())
          names.forEach(name => {
            let nEntry = Object.assign({}, entry)
            nEntry.abc = name
            nAll.push(nEntry)
          })
        })

        let sorted = _.sortBy(nAll, ['abc', 'title'], ['asc'])
        let group = _(sorted).groupBy('abc[0]').map((contacts, letter) => ({ letter, contacts })).value()
        return group
      } else {
        return false
      }
    }
  },

  methods: {
    checkYear (index, pIndex) {
      let tY = this.all[index].contacts[pIndex].title.toLowerCase()
      let lY = pIndex !== 0 ? this.all[index].contacts[pIndex - 1].title.toLowerCase() : ''
      let fY = this.all[index].contacts[pIndex + 1] ? this.all[index].contacts[pIndex + 1].title.toLowerCase() : ''
      if (tY === lY || tY === fY) {
        return `, ${this.all[index].contacts[pIndex].year.title}`
      }
    },

    goToRoute (e, year, slug) {
      if (this.$route.name === 'current') {
        this.$router.push('/laureat/' + year + '/' + slug)
      } else {
        let rP = this.$route.path + '/' + year + '/' + slug
        this.$router.push(rP)
      }
    },

    afterEnter () {
      this.entered = true
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/variables.scss';
#list {
  background-color: white;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  transition: opacity $ease ease;
  position: fixed;
  width: 100%;
  max-height: calc(var(--vh, 1vh) * 100);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 4rem calc(#{$menu} + 4rem);
  top: 0;
  left: 0;
  text-align: center;
}

.person {
  width: 75%;
  margin: 0 auto;
  border-bottom: $line;
  padding: .5rem 0;
}

@media screen and (max-width: $breakPoint1) {
  .person {
    border-bottom: $line2;
  }

  #list {
    padding: calc(#{$moblogo} + 4rem) 4rem calc(#{$menu} + 4rem);
  }
}
</style>
